export default __webpack_public_path__ + "static/media/Callidus.e790cccb.jpg";